import { memo, useState } from "react";
import { Outlet } from "infrastructure/router";
import Box from "@mui/material/Box";
import QueryBuilder from "ui/organizms/QueryBuilder";
import Conditions from "./Conditions";
import Aggregations from "./Aggregations";
import Sorts from "./Sorts";
import Screen, { type ScreenProps } from "ui/layouts/Screen";

const QueryBuilderScreen = () => {
    const [updatedConditions, setUpdatedConditions] = useState<{
        dropdown1: string;
        dropdown2: string;
        inputValue: string;
        condition: string;
    }[]>([]);

    const [updatedAggregations, setUpdatedAggregations] = useState<{
        dropdown1: string;
        dropdown2: string;
        aggregation: string;
    }[]>([]);

    const [updatedSorts, setUpdatedSorts] = useState<{
        dropdown1: string;
        dropdown2: string;
        sort: string;
    }[]>([]);

    const handleUpdateConditions = (conditions: any[]) => {
        setUpdatedConditions(conditions);
    };

    const handleUpdateAggregations = (aggregations: any[]) => {
        setUpdatedAggregations(aggregations);
    };

    const handleUpdateSorts = (sorts: any[]) => {
        setUpdatedSorts(sorts);
    };

    const handleConditionTextAreaChange = (value: string) => {
        // todo sync this readonly textarea with the searchQuery text area
    };

    // todo the box conditions should be emptied when switching between es-transactions and es-merchant-payout-files
    // todo and also globalThis.elasticSearchConditionColumns should be unset
    return (
        <Box>
            <Conditions onUpdateRows={handleUpdateConditions} />
            <Aggregations onUpdateAggregations={handleUpdateAggregations} />
            <Sorts onUpdateSorts={handleUpdateSorts} />
            <QueryBuilder updatedConditions={updatedConditions}
                updatedAggregations={updatedAggregations}
                updatedSorts={updatedSorts}
                onConditionTextAreaChange={handleConditionTextAreaChange}
            >
                <Outlet />
            </QueryBuilder>
        </Box>
    );
};

export default memo((props: ScreenProps) => (
    <Screen
        {...props}
        title='Query Builder'
    >
        <QueryBuilderScreen />
    </Screen>
));
